import { useSelector } from 'react-redux';
import { selectors as appConfigSelectors } from 'modules/appConfig';

import {
	ThemeProvider as UcThemeProvider,
	ThemeProviderProps as UcThemeProviderProps,
	CssBaseline,
} from '@liquidweb-dev/undercurrent';
import { Toaster } from '@liquidweb-dev/undercurrent/toast';
import liquidwebTheme from '@liquidweb-dev/undercurrent/themes/liquidweb';
import nexcessTheme from '@liquidweb-dev/undercurrent/themes/nexcess';

import { DevThemeProvider, useDevTheme } from 'contexts/DevThemeContext';

export type ThemeProviderProps = UcThemeProviderProps;

// Inner component reads the dev brand override from context (set by HeadsUpDisplay).
const UcThemeWrapper = ({ children, ...props }: ThemeProviderProps) => {
	const appConfig = useSelector(appConfigSelectors.getAppConfig);
	const { brand } = useDevTheme();

	const themeName = brand ?? appConfig?.theme;
	const theme = themeName === 'nexcess' ? nexcessTheme : liquidwebTheme;

	return (
		<UcThemeProvider defaultMode="light" theme={theme} {...props}>
			<CssBaseline />
			{children}
			<Toaster />
		</UcThemeProvider>
	);
};

// Outer wrapper provides the DevThemeContext so both ThemeProvider and HeadsUpDisplay
// can access it — HeadsUpDisplay writes the brand, UcThemeWrapper reads it.
const ThemeProvider = ({ children, ...props }: ThemeProviderProps) => {
	return (
		<DevThemeProvider>
			<UcThemeWrapper {...props}>{children}</UcThemeWrapper>
		</DevThemeProvider>
	);
};

export default ThemeProvider;
